import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import LogoIcon from 'components/App/Header/Logo/LogoIcon'
import zIndex from 'styles/tools/z-index'

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: ${zIndex.modal};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${rem(24)};
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
`

function OidcSessionRestoreOverlay() {
  const intl = useIntl()

  return <Overlay role="status" aria-live="polite">
    <Group direction="vertical" gap={16} horizontalAlign="center">
      <LogoIcon />
      <LoadingIndicator inline />
      <BodyText variant="medium" align="center">
        {intl.formatMessage({
          id: 'nmZN9HTkPkNxnP4GiZed',
          defaultMessage: 'Welcome back — signing you in again...',
          description: 'Full-screen message shown while an expired Agent Hub session is automatically restored on page load',
        })}
      </BodyText>
    </Group>
  </Overlay>
}

export default OidcSessionRestoreOverlay
